import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import type { InterviewResultRequest } from '@recruitee/interview-result-request-types';
import { ButtonComponent, DateComponent, IconComponent } from '@recruitee/user-interface';

@Component({
  selector: 'rt-interview-request-item',
  templateUrl: 'interview-request-item.component.html',
  styleUrls: ['./interview-request-item.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, DateComponent, ButtonComponent, TranslatePipe],
})
export class InterviewRequestItemComponent {
  @Input()
  public request: InterviewResultRequest;

  public startEvaluationClick = output<InterviewResultRequest>();
}
